export const MAINAPIURL = "https://gymapi.dsmapps.com/api";
//export const MAINAPIURL = "http://localhost/Backend/api";
export const SYSTEMNAME = "Gym Master :: Member Portal";
export const MAINVERSION = "1.0.0";
export const CUSTOMERNAME = "Actics Fitness Studio";
export const APPBACKGROUND_COLOR = "#f8fafc";

// PDF / Report Settings — keep in sync with AdminFrontend appsettings.js
export const COMPANY_NAME = "Actics Fitness Studio";
export const COMPANY_ADDRESS_LINE1 = "123 Fitness Street";
export const COMPANY_ADDRESS_LINE2 = "Colombo, Sri Lanka";
export const COMPANY_PHONE = "+94 77 123 4567";
export const COMPANY_LOGO_PATH = "/sitelogo.png";
export const REPORT_FOOTER_TEXT = "Generated by GYM Master System";